// export default AuthService;

// services/AuthService.ts
import { privateRequest, publicRequest } from "../../axios";
import { type AxiosResponse } from "axios";
import type {
  ForgotPasswordRequest,
  LoginOTPRequest,
  LoginRequest,
  LoginResponse,
  ReferralSignUp,
  ResetPasswordRequest,
  signUpRequest,
  WebAppConfig,
  DailyAttendanceReports,
  DailyAttendanceReportsResponse,
  GetUserActivityDashboardResponse,
  GetUserReportResponse,
  UserReports,
  UserLocation,
  UserCallLogs,
  TeamWiseGlobalMapData,
  UserWiseGlobalMapData,
  TimelineResponse,
  TeamLeadRoaster,
  TeamAppLogs,
  CutomerReqPayload,
  CustomerResponse,
  SupplierItems,
  SupplierResponse,
  InventoryPayload,
  InventoryResponse,
  AddInventoryPayload,
} from "./auth.interface";

// Define the request/response types
let url: string | undefined = window.location.href;
url = url.split("/")[2];
// url = "testffc.nimapinfotech.com";
const ENDPOINTS = {
  WEBAPP: `api/WebAppSetting?url=${url}`,
  LOGIN: "api/account/authenticate",
  LOGIN_WITH_OTP: "api/Account/LoginWithOTP",
  LOGOUT: "api/auth/logout",
  GENERATE_LOGIN_OTP: "api/Account/GenerateLoginOTP",
  SIGN_UP: "api/WebUserRegister",
  GET_COUNTRIES: "api/Location/Countries",
  RESET_PASSWORD: "api/Account/ForgetPassword",
  REFERRAL_LINK: "referral/ReferralRedirect/SignUp",
  DAILY_ATTENDANCE_REPORT: "api/GC/DailyAttendanceReport",
  GET_USER_ACTIVITY_DASHBOARD: `api/CRM/UserActivityDashboard`,
  USER_REPORT: "api/UserReport",
  LOCATION: "api/User/Location",
  CALL_LOGS_BY_USERID: "api/CRM/CallLogsByUserId",
  TEAM_DATEWISE_GLOBAL_MAP_DATA: "api/CRM/MyTeamDateWiseGlobalMapDataForWeb",
  USER_DATAWISE_GLOBAL_MAP_DATA: "api/UserDateWiseGlobalMapData",
  TIMELINE: "api/CRM/TimeLine",
  LEAD_ROSTER: "api/CRM/LeadRoster",
  APP_LOGS: "api/AppLogs",
  DISLOGIN: "api/Account/Authenticate",
  DISGENERATE_LOGIN_OTP: "api/Account/GenerateOtp",
  DISVALIDATE_WITH_OTP: "api/Account/ValidateOtp",
  DISSIGN_UP: "api/Account/Register",
  GETCUSTOMERREQUEST: "api/CRM/Distributors",
  GET_STATES: "api/Location/States/?countryId=",
  GET_CITY: "api/Location/Cities?stateId=",
  GETSUPPLIERLIST: "/api/Inventory/AllInventory",
  GETINVENTORYLIST: "/api/Inventory/AllInventory",
  ADDINVENTORY: "/api/Inventory",
  GETPURCHASEORDER: "/api/Purchase",
  ADDPURCHASEORDER: "/api/Purchase",
  GETLOCALITY: "/api/Location/Localities?cityId=",
  GETRETAILER: "/api/Retailer/GetRetailers",
  ADDRETAILER: "/api/Retailer/AddRetailer",
  GETSPECIFICRETAILER: "/api/retailer/",
  EDITRETAILER: "/api/Retailer/",
  DELETERETAILER: "/api/Retailer/",
  RETAILERSTATUS: "/api/Retailer/RetailerStatus",
  GETWAREHOUSE: "/api/Warehouse/GetAll",
  GETSPECIFICWAREHOUSE: "/api/Warehouse/",
  ADDWAREHOUSE: "/api/Warehouse",
  EDITWAREHOUSE: "/api/Warehouse/",
  DELETEWAREHOUSE: "/api/Warehouse/",
  GETRETILERSIGNUPLINK: "/api/Account/RetailerSignUpLink",
  GETORDERS: "/api/OrderMaster/GetOrders",
  ADDORDERS: "/api/OrderMaster/AddOrder",
  ORDERSTATUS: "/api/OrderMaster/Approval-Rejection",
  RETAILEROPTIONLIST: "/api/Retailer/Retailers/Name",
  DELETEORDER: "/api/OrderMaster/",
  PRODUCT_LIST: "/api/Inventory/Products",
  DELIVERY_ORDER : "/api/Sales",
  ORDER_DETAILS :  "/api/OrderMaster/Products",
  INVENTORY_PRODUCT : "/api/Inventory/Inventory/Products"
};

// const login = async (
//   data: LoginRequest
// ): Promise<LoginResponse> => {
//   const response: AxiosResponse<LoginResponse> = await publicRequest.post(
//     ENDPOINTS.LOGIN,
//     data
//   );
//   return response.data;
// };

interface Country {
  countryId: number;
  name: string;
  countryCode: string;
}
interface State {
  stateId: number;
  name: string;
  countryId: number;
}
interface City {
  cityId: number;
  name: string;
  stateId: number;
}

interface Locality {
  LocalityId: number;
  Name: string;
  LocalityCode: string;
}
interface ApiResponse<T = any> {
  Status: number;
  Message: string;
  data: T;
}
const webAppSetting = async (): Promise<WebAppConfig> => {
  try {
    const response: AxiosResponse<WebAppConfig> = await publicRequest.get(
      ENDPOINTS.WEBAPP
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const login = async (data: LoginRequest): Promise<LoginResponse> => {
  try {
    const response: AxiosResponse<LoginResponse> = await publicRequest.post(
      ENDPOINTS.LOGIN,
      data
    );

    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};
const loginWithOtp = async (data: LoginOTPRequest): Promise<LoginResponse> => {
  try {
    const response: AxiosResponse<LoginResponse> = await publicRequest.post(
      ENDPOINTS.LOGIN_WITH_OTP,
      data
    );

    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const logout = async (): Promise<{ message: string }> => {
  const response: AxiosResponse<{ message: string }> =
    await privateRequest.post(ENDPOINTS.LOGOUT);
  return response.data;
};

const GenerateLoginOTP = async (
  data: ForgotPasswordRequest
): Promise<{ message: string }> => {
  try {
    const response: AxiosResponse<{ message: string }> =
      await publicRequest.post(ENDPOINTS.GENERATE_LOGIN_OTP, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });

    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const signUp = async (data: signUpRequest): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await publicRequest.post(
      ENDPOINTS.SIGN_UP,
      data
    );
    if (response.data.Status !== 200) {
      return Promise.reject(response.data);
    }

    return response.data;
  } catch (error: any) {
    return Promise.reject(
      error.response?.data || { Message: error.message, Status: 500 }
    );
  }
};

const getCountries = async (): Promise<Country[]> => {
  try {
    const response = await publicRequest.get<Country[]>(
      ENDPOINTS.GET_COUNTRIES
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const resetPassword = async (
  data: ResetPasswordRequest
): Promise<{ message: string }> => {
  try {
    const response: AxiosResponse<{ message: string }> =
      await publicRequest.post(ENDPOINTS.RESET_PASSWORD, data);
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};


const DailyAttendanceReport = async (
  datas: any
): Promise<DailyAttendanceReportsResponse> => {
  try {
    const response: AxiosResponse<DailyAttendanceReportsResponse> =
      await privateRequest.post(ENDPOINTS.DAILY_ATTENDANCE_REPORT, datas);

    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};
const UserActivityDashboard = async (userId: number) => {
  try {
    const response: AxiosResponse<GetUserActivityDashboardResponse> =
      await privateRequest.get(
        `${ENDPOINTS.GET_USER_ACTIVITY_DASHBOARD}?UserId=${userId}`
      );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const UserReport = async (userReportData: any): Promise<UserReports> => {
  try {
    const response: AxiosResponse<UserReports> = await privateRequest.post(
      ENDPOINTS.USER_REPORT,
      userReportData
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const USerLocation = async (payload: any): Promise<UserLocation> => {
  try {
    const response: AxiosResponse<UserLocation> = await privateRequest.get(
      `${ENDPOINTS.LOCATION}?userId=${payload.userId}&fromDate=${payload.fromDate}&todate=${payload.toDate}`
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const CallLogsByUserId = async (payload: any): Promise<UserCallLogs> => {
  try {
    const response: AxiosResponse<UserCallLogs> = await privateRequest.get(
      `${ENDPOINTS.CALL_LOGS_BY_USERID}?userId=${payload.userId}&fromDate=${payload.fromDate}&todate=${payload.toDate}`
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const MyTeamDateWiseGlobalMap = async (
  date: any
): Promise<TeamWiseGlobalMapData> => {
  try {
    const response: AxiosResponse<TeamWiseGlobalMapData> =
      await privateRequest.get(
        `${ENDPOINTS.TEAM_DATEWISE_GLOBAL_MAP_DATA}?date=${date}`
      );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const UserDateWiseGlobalMapData = async (
  payload: any
): Promise<UserWiseGlobalMapData> => {
  try {
    const response: AxiosResponse<UserWiseGlobalMapData> =
      await privateRequest.get(
        `${ENDPOINTS.USER_DATAWISE_GLOBAL_MAP_DATA}?userId=${payload.userId}&date=${payload.date}`
      );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const Timeline = async (
  payload: any
): Promise<AxiosResponse<TimelineResponse>> => {
  try {
    const response: AxiosResponse<TimelineResponse> = await privateRequest.post(
      ENDPOINTS.TIMELINE,
      payload
    );
    return response;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const LeadRoaster = async (payload: any): Promise<TeamLeadRoaster> => {
  try {
    const response: AxiosResponse<TeamLeadRoaster> = await privateRequest.post(
      ENDPOINTS.LEAD_ROSTER,
      payload
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const AppLogs = async (payload: any): Promise<TeamAppLogs> => {
  try {
    const response: AxiosResponse<TeamAppLogs> = await privateRequest.post(
      `${ENDPOINTS.APP_LOGS}?ForUserId=${payload.ForUserId}&From=${payload.From}&FromDate=${payload.FromDate}&To=${payload.To}&ToDate=${payload.ToDate}`
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const DisLogin = async (payload: LoginRequest): Promise<LoginResponse> => {
  try {
    const response: ApiResponse<LoginResponse> = await publicRequest.post(
      ENDPOINTS.DISLOGIN,
      payload
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const DisGenerateLoginOtp = async (
  data: ForgotPasswordRequest
): Promise<{ message: string }> => {
  try {
    const response: AxiosResponse<{ message: string }> =
      await publicRequest.post(
        `${ENDPOINTS.DISGENERATE_LOGIN_OTP}?emailId=${data}`
      );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const DisValLoginOtp = async (
  data: LoginOTPRequest
): Promise<LoginResponse> => {
  try {
    const response: AxiosResponse<LoginResponse> = await publicRequest.post(
      `${ENDPOINTS.DISVALIDATE_WITH_OTP}?emailId=${data.emailOrMobileNo}&otp=${data.otp}`
    );

    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const DisSignUp = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await publicRequest.post(
      ENDPOINTS.DISSIGN_UP,
      data
    );

    if (response.data.status !== 200) {
      return Promise.reject(response.data);
    }

    return response.data;
  } catch (error: any) {
    return Promise.reject(
      error.response?.data || { Message: error.message, Status: 500 }
    );
  }
};

const GetCustomerRequest = async (
  payload: CutomerReqPayload
): Promise<CustomerResponse> => {
  try {
    const response = await publicRequest.post(
      ENDPOINTS.GETCUSTOMERREQUEST,
      payload
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

// const GetCountry = async (): Promise<Country[]> => {
//   try {
//     const response = await publicRequest.get<ApiResponse<Country[]>>(
//       ENDPOINTS.GETREFERRALCOUNTIRES
//     );

//     if (response.data.Status !== 200) {
//       throw new Error("Failed to load countries");
//     }

//     return response.data.data;
//   } catch (error: any) {
//     throw error.response?.data || error;
//   }
// };

interface ApiResponse<T> {
  message: string;
  status: number;
  data: T;
}

const GetState = async (CountryId: number): Promise<State[]> => {
  try {
    const response = await publicRequest.get<ApiResponse<State[]>>(
      `${ENDPOINTS.GET_STATES}${CountryId}`
    );
    return response.data.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

// const GetState = async (CountryId:number): Promise<State[]> => {
//   try {
//     const response = await publicRequest.get<State[]>(
//       `${ENDPOINTS.GET_STATES}${CountryId}`
//     );

//     return response.data.data;
//   } catch (error: any) {
//     throw error.response?.data || error;
//   }
// };

const GetCity = async (StateId: number): Promise<City[]> => {
  try {
    const response = await publicRequest.get<ApiResponse<City[]>>(
      `${ENDPOINTS.GET_CITY}${StateId}`
    );

    return response.data.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const GetLocality = async (CityId: number): Promise<Locality[]> => {
  try {
    const response = await publicRequest.get<ApiResponse<Locality[]>>(
      `${ENDPOINTS.GETLOCALITY}${CityId}`
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const SupplierList = async (
  payload: InventoryPayload
): Promise<SupplierResponse> => {
  try {
    const response = await privateRequest.get<SupplierResponse>(
      ENDPOINTS.GETSUPPLIERLIST,
      { params: payload }
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

// const AddRetailer=async(payload:InventoryPayload):Promise<SupplierResponse>=>{
//   try{
//     const response=await privateRequest.get<SupplierResponse>(ENDPOINTS.GETSUPPLIERLIST,{params:payload})
//     return response.data
//   }
//   catch(error:any){
//     throw error.response?.data || error;
//   }
// }

// const InventoryList=async(payload:InventoryPayload):Promise<InventoryResponse>=>{
//   try{
//     const response=await privateRequest.get<InventoryResponse>(ENDPOINTS.GETINVENTORYLIST,payload)
//     return response.data

//   }

//   catch(error:any){
//   throw error.response?.data||error;
//   }
// }

const AddInventory = async (payload: AddInventoryPayload): Promise<any> => {
  try {
    const response = await privateRequest.post<ApiResponse<any>>(
      ENDPOINTS.ADDINVENTORY,
      payload
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const PurchaseList = async (payload: any): Promise<any> => {
  try {
    const response = await privateRequest.get(
      `${ENDPOINTS.GETPURCHASEORDER}?from=${payload.from}&to=${payload.to}`
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const AddPurchaseList = async (payload: any): Promise<any> => {
  try {
    const response = await privateRequest.post(ENDPOINTS.ADDPURCHASEORDER, {
      params: payload,
    });
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const GetRetailerList = async (params: any) => {
  try {
    const response = await privateRequest.post(`${ENDPOINTS.GETRETAILER}?from=${params.from}&to=${params.to}&searchName=${params.searchName}&status=${params.status}`);
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const AddRetailer = async (data: any) => {
  try {
    const response = await privateRequest.post(ENDPOINTS.ADDRETAILER, data);
    return response?.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const EditRetailer = async (id: any, data: any) => {
  try {
    const response = await privateRequest.put(
      `${ENDPOINTS.EDITRETAILER}${id}`,
      data
    );
    return response?.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};
const DeleteRetailer = async (id: any) => {
  try {
    const response = await privateRequest.delete(
      `${ENDPOINTS.DELETERETAILER}${id}`
    );
    return response?.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const RetailerStatus = async (data: any) => {
  try {
    const response = await privateRequest.put(ENDPOINTS.RETAILERSTATUS, data);
    return response;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const GetWarehouseList = async (data: any) => {
  try {
    const response = await privateRequest.post(ENDPOINTS.GETWAREHOUSE, data);
    return response?.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const AddWarehouse = async (data: any) => {
  try {
    const response = await privateRequest.post(ENDPOINTS.ADDWAREHOUSE, data);
    return response?.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const EditWarehouse = async (id: any, data: any) => {
  try {
    const response = await privateRequest.put(
      `${ENDPOINTS.EDITWAREHOUSE}${id}`,
      data
    );
    return response?.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const DeleteWarehouse = async (id: any) => {
  try {
    const response = await privateRequest.delete(
      `${ENDPOINTS.DELETEWAREHOUSE}${id}`
    );
    return response?.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};
const GetSpecificWarehouse = async (id: any) => {
  try {
    const response = await privateRequest.get(
      `${ENDPOINTS.GETSPECIFICWAREHOUSE}${id}`
    );
    return response?.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const GetSpecificRetailer = async (id: any) => {
  try {
    const response = await privateRequest.get(
      `${ENDPOINTS.GETSPECIFICRETAILER}${id}`
    );
    return response?.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const RetailerReferealLink = async () => {
  try {
    const response = await privateRequest.get(ENDPOINTS.GETRETILERSIGNUPLINK);
    return response?.data?.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const GetOrders = async (data: any) => {
  try {
    const { from, to, status, search } = data;
    const url = `${ENDPOINTS.GETORDERS}?from=${from}&to=${to}&status=${status}&search=${search}`;
    const response = await privateRequest.post(url);
    return response?.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const AddOrders = async (data: any) => {
  try {
    const response = await privateRequest.post(ENDPOINTS.ADDORDERS, data);
    return response?.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const OrderStatus = async (data: any) => {
  try {
    const response = await privateRequest.post(ENDPOINTS.ORDERSTATUS, data);
    return response?.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};
const GetRetailerOption = async () => {
  try {
    const response = await privateRequest.get(ENDPOINTS.RETAILEROPTIONLIST);
    return response?.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const GetOrderDetail = async (data: any) => {
  try {
    const url = `${ENDPOINTS.GETORDERS}/${data}`;

    const response = await privateRequest.post(url);
    return response?.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const DeleteOrder = async (id: any) => {
  try {
    const response = await privateRequest.delete(
      `${ENDPOINTS.DELETEORDER}${id}`
    );
    return response?.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const GetProductOption = async () => {
  try {
    const response = await privateRequest.get(ENDPOINTS.PRODUCT_LIST);
    return response?.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const GetSpecificOrders = async (orderId: any) => {
  try {
    const url = `${ENDPOINTS.GETORDERS}/${orderId}`;

    const response = await privateRequest.post(url);
    return response?.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const GetInventoryList = async (params : any) => {
  try {
    const response = await privateRequest.get(`${ENDPOINTS.INVENTORY_PRODUCT}?from=${params.from}&to=${params.to}&search=${params.search}`);
    return response;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const AddDeliveredOrder = async (data: any) => {
  try {
    const response = await privateRequest.post(ENDPOINTS.DELIVERY_ORDER, data);
    return response?.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};


const getspecificorderDetails = async (orderId : any) => {
  try {
    const response = await privateRequest.get(`${ENDPOINTS.ORDER_DETAILS}/${orderId}`);
    return response?.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const AuthService = {
  login,
  logout,
  GenerateLoginOTP,
  resetPassword,
  webAppSetting,
  signUp,
  getCountries,
  loginWithOtp,
  DailyAttendanceReport,
  UserActivityDashboard,
  UserReport,
  USerLocation,
  CallLogsByUserId,
  MyTeamDateWiseGlobalMap,
  UserDateWiseGlobalMapData,
  Timeline,
  LeadRoaster,
  AppLogs,
  DisLogin,
  DisGenerateLoginOtp,
  DisValLoginOtp,
  DisSignUp,
  GetCustomerRequest,

  GetState,
  GetCity,
  GetLocality,
  SupplierList,
  //  InventoryList,
  AddInventory,
  PurchaseList,
  AddPurchaseList,
  GetRetailerList,
  AddRetailer,
  EditRetailer,
  DeleteRetailer,
  RetailerStatus,
  GetSpecificRetailer,
  GetWarehouseList,
  GetSpecificWarehouse,
  AddWarehouse,
  EditWarehouse,
  DeleteWarehouse,
  RetailerReferealLink,
  AddOrders,
  GetOrders,
  OrderStatus,
  GetRetailerOption,
  GetOrderDetail,
  DeleteOrder,
  GetProductOption,
  GetSpecificOrders,
  GetInventoryList,
  AddDeliveredOrder,
  getspecificorderDetails
};

export default AuthService;
